import config from '@/config/config';


/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
  routerBack 是否显示返回按钮
*/

const visitorMode = Boolean(process.env.VUE_APP_VISITOR_MODE)

const routeMap = [
			{
				path: '/login',
				name: 'Login',
				component: () => import('@/views/user/Login'),
				meta: { name: '登录', noLogin: config.visitorMode, routerBack: false }
			},
			{
				path: '/register',
				name: 'Register',
				component: () => import('@/views/user/Register'),
				meta: { name: '注册', noLogin: config.visitorMode }
			},
			{
				path: '/search',
				name: 'Search',
				component: () => import('@/views/Search'),
				meta: { name: '搜索', noLogin: config.visitorMode }
			},
			{
				path: '/location',
				name: 'location',
				component: () => import('@/views/location'),
				meta: { name: '位置' }
			},
			{
				path: '/product',
				name: 'Product',
				component: () => import('@/views/product'),
				meta: { name: '商品', noLogin: config.visitorMode }
			},
			{
				path: '/order',
				name: 'Order',
				component: () => import('@/views/myOrder/orderList'),
				meta: { name: '订单' }
			},
			{
				path: '/orderInfo',
				name: 'orderInfo',
				component: () => import('@/views/myOrder/orderInfo'),
				meta: { name: '订单详情' }
			},
			{
				path: '/myaddress',
				name: 'Myaddress',
				component: () => import('@/views/myaddress/addressList'),
				meta: { name: '我的地址' }
			},
			{
				path: '/editaddress',
				name: 'editaddress',
				component: () => import('@/views/myaddress/addressInfo'),
				meta: { name: '修改地址' }
			},
			{
				path: '/orderhistory',
				name: 'orderhistory',
				component: () => import('@/views/myOrder/orderhistory'),
				meta: { name: '订单记录' }
			},
			{
				path: '/service',
				name: 'service',
				redirect: '/sceneval',
				component: () => import('@/views/service'),
				children: [
					{
						path: '/sceneval',
						name: 'sceneval',
						component: () => import('@/views/service/children/sceneval'),
						meta: { name: '售后服务' }
					}
				],
				meta: { tabShow: true }
			},
			{
				path: '/userinfo',
				name: 'userInfo',
				component: () => import('@/views/userInfo'),
				meta: { name: '个人信息' }
			},
			// {
			// 	path: '/resetpassword',
			// 	name: 'resetPassword',
			// 	component: () => import('@/views/user/resetPassword'),
			// 	meta: { name: '忘记密码' },
			// },
			{
				path: '/welfare',
				name: 'welfare',
				component: () => import('@/views/welfare'),
				meta: { name: '我的福利' }
			},
			{
				path: '/prodetail',
				name: 'prodetail',
				component: () => import('@/views/prodetail'),
				meta: { name: '商品详情', noLogin: config.visitorMode }
			},
			{
				path: '/payment',
				name: 'payment',
				component: () => import('@/views/payment'),
				meta: { name: '确认订单' }
			},
			{
				path: '/mydiylist',
				name: 'myDiyList',
				component: () => import('@/views/gift/component/myDiyList'),
				meta: { name: '我的DIY' }
			},
			{
				path: '/logistic',
				name: 'logistic',
				component: () => import('@/views/logistic'),
				meta: { name: '商品物流' }
			},
			{
				path: '/makingCard',
				name: 'makingCard',
				component: () => import('@/views/gift/component/makingCard'),
				meta: { name: '个性定制' }
			},
			{
				path: '/payOrderStatus',
				name: 'payOrderStatus',
				component: () => import('@/views/payment/payOrderStatus')
			},
			{
				path: '/UserInfoHandle',
				name: 'UserInfoHandle',
				component: () => import('@/views/UserInfoHandle')
			},
			{
				path: '/bindTel',
				name: 'bindTel',
				component: () => import('@/views/bindTel')
			},
			{
				path: '/payment2',
				name: 'payment2',
				component: () => import('@/views/payment2')
			}
]

export default routeMap;
